import { BearingEnvelope } from '@paragon/contract-library';
import { Point2D, Vector2D } from '@paragon/geometry-library';

export function translateBearingEnvelope(envelope: BearingEnvelope, delta: Vector2D): BearingEnvelope {
  return {
    ...envelope,
    leftPoint: Point2D.fromObject(envelope.leftPoint).translate(delta).toObject(),
    rightPoint: Point2D.fromObject(envelope.rightPoint).translate(delta).toObject(),
  };
}
